import React, { useEffect, useState } from "react";
import {
  PagePermissionNameData,
  usePermissionsChecker,
} from "../../../helpers/permissionModule";
import FullScreenLoader from "../../Components/FullScreenLoader";
import { RootState, useAppDispatch, useAppSelector } from "../../../store";
import NoPermissionPage from "../../Components/NoPermissionPage";
import { useNavigate, useParams } from "react-router-dom";
import { svg } from "../../../Assets/svg";
import { getMachineDetailsAPI } from "../../Redux/masterData";
import { Spin, Table } from "antd";
import NoDataMessage from "../../Components/NoData";

import { OrderStatusEnum, OrderStatusLabels } from "../Orders/orderTypes";
import { statusFindClass } from "../Orders/Orders";

const MachineDetails = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const USER_PERMISSIONS = usePermissionsChecker(
    PagePermissionNameData?.MASTER_DATA,
  );
  const { authLoading } = useAppSelector((state: RootState) => state.loading);

  const [loading, setLoading] = useState(false);
  const [machineData, setMachineData] = useState([]);

  const fetchMachineDetails = () => {
    if (id) {
      setLoading(true);
      dispatch(
        getMachineDetailsAPI({
          machineId: id,
          onSuccess: (data) => {
            const mData = data || [];
            setMachineData(mData);
            setLoading(false);
          },
          onError: () => {
            setLoading(false);
          },
        }),
      );
    }
  };

  useEffect(() => {
    if (id) {
      fetchMachineDetails();
    }
  }, [id]);

  const columns = [
    {
      title: "Order Number",
      dataIndex: "order_id",
      key: "order_id",
      render: (order_id: any) => (
        <span className="fw-bold text-dark">{order_id || "-"}</span>
      ),
    },
    {
      title: "Customer Name",
      key: "customer_name",
      render: (_: any, record: any) => {
        const fullName = [record.first_name, record.last_name]
          .filter(Boolean)
          .join(" ");
        return <span className="fw-bold text-dark">{fullName || "-"}</span>;
      },
    },
    {
      title: "Status",
      dataIndex: "order_status",
      key: "order_status",
      render: (order_status: any) => {
        const statusLabel =
          OrderStatusLabels[order_status as OrderStatusEnum] || order_status;
        return (
          <span
            className={
              "d-inline-flex align-items-center billStatus " +
              statusFindClass(order_status)
            }
          >
            {svg.dotIcon}
            {statusLabel || "-"}
          </span>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_: unknown, record: any) => {
        return (
          <div
            className="order-md-3 btn btn-primary d-inline-flex align-items-center justify-content-center"
            onClick={() => {
              const orderId = record?._id;
              if (orderId) {
                navigate(`/orders/${orderId}?tab=production-planning`, {
                  state: {
                    backPath: `/master-data/machines-departments/${id}/details`,
                    isFromMachine:true
                  },
                });
              }
            }}
          >
            Update Production Plan
          </div>
        );
      },
    },
  ];

  if (authLoading) {
    return <FullScreenLoader />;
  }

  if (!USER_PERMISSIONS.READ) {
    return <NoPermissionPage />;
  }

  return (
    <div className="page-content h-100 px-40 py-40 bg-light d-flex flex-column">
      <div className="mb-3 d-flex align-items-center justify-content-between gap-3 flex-shrink-0">
        <div className="d-flex align-items-center gap-2">
          <span
            className="cursor-pointer svg-24"
            onClick={() => {
              navigate(`/master-data/machines-departments`);
            }}
          >
            {svg?.backArrow || "←"}
          </span>
          <h2 className="fs-36 fw-bold page-title mb-0">
            Orders Using This Machine
          </h2>
        </div>
      </div>

      {loading ? (
        <div className="text-center p-5">
          <Spin size="large" />
        </div>
      ) : machineData?.length === 0 ? (
        <div className="p-4">
          <NoDataMessage
            icon={svg?.noProductsIcon}
            text="No orders found for this machine."
          />
        </div>
      ) : (
        <Table
          dataSource={machineData}
          scroll={{ x: "max-content" }}
          pagination={false}
          columns={columns}
          // onChange={handleTableChange}
          rowKey={(record) => record._id}
          className="variant-edit-table bg-white"
          bordered
        />
      )}
    </div>
  );
};

export default MachineDetails;
